<template>
    <div style="display: none;">
        <webviewnowin v-for="(s, index) in shopids" :key="index" :ref="'webviewnowin-' + s"></webviewnowin>
    </div>
</template>
<script>
import webviewnowin from '@/views/admin/com/webviewnowin.vue';
export default {
    data() {
        return {
            shopids: [],
            shopInit: {},
        }
    },
    components: {
        webviewnowin,
    },
    methods: {
        arraysHaveSameValues: function (a, b) {
            if (a.length !== b.length) return false;
            const sortedA = [...a].sort();
            const sortedB = [...b].sort();
            return sortedA.every((val, index) => val === sortedB[index]);
        },
        removeShop: function (shopId) {
            for (let i = 0; i < this.shopids.length; i++) {
                if (this.shopids[i] == shopId) {
                    this.shopids.splice(i, 1);
                }
            }
        },
        init: function (shopids) {
            if (!this.arraysHaveSameValues(this.shopids, shopids)) {
                this.shopInit = {};
                return new Promise(r => {
                    this.shopids = shopids;
                    this.$nextTick(async () => {
                        for (let i = 0; i < shopids.length; i++) {
                            let id = shopids[i];
                            await this.$refs['webviewnowin-' + id][0].open({ id: id });
                            this.shopInit[id] = true;
                            console.log("===========id", id)
                        }
                        r(true);
                    });
                })
            }
            return true;
        },
        publish: async function (shop, schema) {
            if (this.shopInit[shop.id] === true) {
                let rs = await this.$refs['webviewnowin-' + shop.id][0].publish(shop, schema);
                console.log("======================webview返回结果", rs)
                return rs;
            } else {
                return { code: -1, msg: "webview还未初始化好" }
            }
        }
    },
}
</script>